/**
 * Converts a snake_case string to Title Case
 * @param enumString The snake_case string to convert
 * @returns Title Case string
 *
 * @example
 * ```typescript
 * snakeCaseToTitleCase('SUCCEEDED'); // "Succeeded"
 * snakeCaseToTitleCase('FAILED_TO_SYNC'); // "Failed To Sync"
 * snakeCaseToTitleCase('NOT_FOUND'); // "Not Found"
 * ```
 */
export function snakeCaseToTitleCase(snakeCaseString: string): string {
  return snakeCaseString
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Converts a snake_case string to camelCase
 * @param snakeCaseString The snake_case string to convert
 * @returns camelCase string
 *
 * @example
 * ```typescript
 * snakeCaseToCamelCase('SUCCEEDED'); // "succeeded"
 * snakeCaseToCamelCase('FAILED_TO_SYNC'); // "failedToSync"
 * ```
 */
export const toCamelCase = (segment: string) =>
  segment.replace(/_([a-z0-9])/g, (_match, char: string) => char.toUpperCase());

/**
 * Pluralizes a word based on the count
 * @param count The number of items
 * @param singular The singular form of the word
 * @param plural The plural form of the word
 * @returns A string with the count and the correct singular/plural form
 *
 * @example
 * ```typescript
 * pluralize(1, 'Account', 'Accounts'); // "1 Account"
 * pluralize(5, 'Account', 'Accounts'); // "5 Accounts"
 * ```
 */
export function pluralize(count: number, singular: string, plural: string): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
